module.exports = __webpack_public_path__ + "img/btn_google_signin_light_pressed_web@2x.80527ac6.png";